import { cn } from '@commenda/utils';

interface TransactionTypeCardProps {
  title: string;
  description: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

const TransactionTypeCard = ({
  title,
  description,
  selected = false,
  onClick,
  className,
}: TransactionTypeCardProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'flex flex-col gap-2 rounded-lg p-4',
        'border transition-all cursor-pointer',
        // Default state
        'border-border-primary',
        // Hover state
        'hover:bg-utility-indigo-50',
        // Selected state
        selected && 'bg-utility-indigo-50 border-utility-indigo-400',
        className
      )}
    >
      <h3 className="txt-medium-bold text-text-primary">{title}</h3>
      <p className="txt-small-medium text-text-tertiary">{description}</p>
    </div>
  );
};

export default TransactionTypeCard;
